const SMS_POPUP_NAME = Object.freeze({
  // flags in the state of a component
  // SEE: src/scheduler/components/common/SmsButtonNew.jsx
  beforeSend: 'beforeSendPopupOpen',
  billing: 'billingPopupOpen',
  exit: 'exitPopupOpen',
  onlineBooking: 'onlineBookingPopupOpen',
  smsCompose: 'smsComposeModalOpen',
  smsSent: 'smsSentModalOpen',

  // not really popups, more like shortcuts
  exitTotally: 'exit-totally',
  success: 'success',
});

// noinspection JSUnusedGlobalSymbols
export default SMS_POPUP_NAME;
